import React from 'react'
import { css } from 'styled-system/css'

import { OnboardingCartBasketSummary } from '@mindfulchefuk/onboarding/components/OnboardingCartDrawer/OnboardingCartBasket/OnboardingCartBasketSummary'
import { OnboardingCartDrawerCallout } from '@mindfulchefuk/onboarding/components/OnboardingCartDrawer/OnboardingCartBasket/OnboardingCartDrawerCallout'
import { OnboardingCartBasketRecipeList } from '@mindfulchefuk/onboarding/components/OnboardingCartDrawer/OnboardingCartBasket/OnboardingCartRecipeList'
import { useChooseRecipesContext } from '@mindfulchefuk/onboarding/context/ChooseRecipesContext/ChooseRecipesContext'
import { OnboardingCartDrawerFooter } from '@mindfulchefuk/onboarding/components/OnboardingCartDrawer/OnboardingCartDrawerFooter'

export const OnboardingCartBasket = () => {
  const {
    totalNumberOfRecipes,
    minimumRecipesForPortion,
    toggleCartDrawer,
    handleConfirmRecipesClick,
  } = useChooseRecipesContext()

  const hasAddedMinimumNumberOfRecipes =
    totalNumberOfRecipes >= minimumRecipesForPortion

  return (
    <div
      className={css({
        marginTop: { base: 6, lg: 8 },
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: '100%',
      })}
    >
      <div className={css({ marginX: 6 })}>
        <OnboardingCartBasketSummary />

        <OnboardingCartDrawerCallout />

        <OnboardingCartBasketRecipeList />
      </div>

      <OnboardingCartDrawerFooter
        hasMinNumberOfRecipes={hasAddedMinimumNumberOfRecipes}
        onClickAboveMinRecipes={handleConfirmRecipesClick}
        onClickBelowMinRecipes={toggleCartDrawer}
      />
    </div>
  )
}
